import type { Dispatch, SetStateAction } from 'react'
import { createContext, useContext } from 'react'

export type StateDefinition = {
  error: boolean
  describedBy?: string
  labelledBy?: string
  groupId: string
}

type ContextDefinition = [
  StateDefinition,
  Dispatch<SetStateAction<string | undefined>>,
]

const defaultState: StateDefinition = { error: false, groupId: '' }

const CheckboxContext = createContext<ContextDefinition>([
  defaultState,
  () => undefined,
])

const useCheckbox = (): ContextDefinition => useContext(CheckboxContext)

export { CheckboxContext, useCheckbox }
